import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { isAdmin } from "@faire/retailer/lib/isAdmin";
import { isUserMakerEditor } from "@faire/retailer/lib/isUserMakerEditor";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { LazyInternalProductActions } from "@faire/retailer/views/product/InternalProductActions/LazyInternalProductActions";
export var EmployeeProductActions = function(param) {
    var product = param.product, isBrandActive = param.isBrandActive;
    var hasFaireEmailAddress = useUserStore([
        "hasFaireEmailAddress"
    ]).hasFaireEmailAddress;
    if (isAdmin() || hasFaireEmailAddress || isUserMakerEditor()) {
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyInternalProductActions, {
                product: product,
                isBrandActive: isBrandActive
            })
        });
    }
    return null;
};
